import { Text } from "@ecco/ui/text";
import { Switch } from "@ecco/ui/switch";
import { Flex } from "@ecco/ui/flex";
import { use } from "react";

import { Controller } from "@components/store-locator/controller";
import { textStyle, wrapperStyle } from "./StoresToggle.styles";
import { Progress } from "@ecco/ui/progress";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { CommonCMS } from "@lib/constants/contentful";
import { storeLocator } from "@lib/constants/contentful/storeLocator";
import { PARTNER_STORES_SWITCH } from "@e2e/helpers/store-locator/constants/common";

export const StoresToggle = () => {
    const { get: getMicrocopy } = useMicrocopy();

    const { setShowPartnerStores, showPartnerStores, isLoading } = use(Controller);

    const onToggle = () => setShowPartnerStores((prev) => !prev);

    const title = getMicrocopy(CommonCMS.page, storeLocator.partnerStores);
    const ariaToggleLabel = getMicrocopy(CommonCMS.page, storeLocator.ariaLabels.loadingToggleAria);

    return (
        <Flex gap={2} justify="center" align="center" sx={wrapperStyle}>
            {isLoading ? (
                <Progress
                    isIndeterminate
                    variant="buttonLoader"
                    aria-label={ariaToggleLabel || "Loading partner stores"}
                />
            ) : (
                <>
                    <Text as="label" id="storeSwitchLabel" sx={textStyle}>
                        {title}
                    </Text>
                    <Switch
                        aria-labelledby="storeSwitchLabel"
                        data-testid={PARTNER_STORES_SWITCH}
                        isChecked={showPartnerStores}
                        onChange={onToggle}
                    ></Switch>
                </>
            )}
        </Flex>
    );
};
